import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { profile } from "../data/profile";
import "../App.css";

function Skills() {
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-out-cubic",
      once: true,
    });
  }, []);

  return (
    <section id="skills" className="site-section site-section--surface">
      <div className="container site-section-inner">
        <header className="section-head">
          {/* <p className="section-eyebrow">Toolkit</p> */}
          <h2 className="section-title">Technical Skills</h2>
          {/* <p className="section-lead">
            Languages, frameworks, cloud, and AI tools used to ship production software.
          </p> */}
        </header>

        <div className="skills-grid">
          {profile.skills.map((group, index) => (
            <article
              className="skill-group"
              key={group.title}
              data-aos="fade-up"
              data-aos-delay={(index % 2) * 60}
            >
              <h3>{group.title}</h3>
              <div className="skill-tags">
                {group.skills.map((skill) => (
                  <span key={skill}>{skill}</span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
